module.exports = __webpack_public_path__ + "media/images/sale_crm/arrow-368bc64e2f558e48bf042298318fd316.svg";